<template>
  <resource
    resource="moderator"
    resourceName="Moderator"
    :attributes="attributes"
  >
    <div slot="title">
      <h4>Moderator erstellen</h4>
    </div>
  </resource>
</template>

<script lang="babel">
export default {
  computed: {
    isAdmin() {
      return this.$store.getters['user/meHasRole']('admin');
    },
    attributes() {
      let attributes = [
        {
          name: 'name',
          label: 'Name',
        },
        {
          name: 'email',
          label: 'E-Mail-Adresse',
        },
        {
          name: 'password',
          label: 'Passwort',
        },
        {
          name: 'asa_only',
          label: 'Nur ASA schreiben',
          type: 'CheckboxSelector',
          value: false
        },
        {
          name: 'min_chars_for_messages',
          label: 'Standard Wert für x Zeichen pro Nachricht',
          type: 'DefaultValueSwitchSelector',
        },
        {
          name: 'min_chars_for_asa',
          label: 'Standard Wert für x Zeichen pro asa Nachricht',
          type: 'DefaultValueSwitchSelector',
        }
      ];

      if (this.isAdmin) {
        attributes.push(
          {
            name: 'agency_id',
            label: 'Agency',
            type: 'DropdownSelector',
            items: this.agencies
          }
        );
      }

      return attributes;
    }
  },
  methods: {
    getAgencies() {
      return this.$http
        .get("/api/v1/agency/agencyListRead")
        .then(({ data }) => {
          for (const [value, text] of Object.entries(data)) {
            this.agencies.push({ value: value, text: value + " - " + text });
          }
        });
    }
  },
  created() {
    this.getAgencies();
  },
  data() {
    return {
      agencies: [],
    }
  }
}
</script>
